import * as Sentry from '@sentry/react'

Sentry.init({
  dsn: 'https://25dc37e4288b4d63a065981d7444bbe6@sentry.io/300639',
  debug: process.env.REACT_APP_ENV === 'development',
  beforeSend: event =>
    process.env.REACT_APP_ENV !== 'development' ? event : null,
  environment: process.env.REACT_APP_ENV
})



// WEBPACK FOOTER //
// ./src/config/sentry.js